/**
 * Tachyons colors
 */
export const actionBg = null;
export const actionText = 'dark-gray';



/** WEBPACK FOOTER **
 ** ./src/components/colors.js
 **/